export default __webpack_public_path__ + "static/media/person-add-white-small.78c3e1eb.svg";